<template>
  <v-card class="account-modal">
    <v-card-title class="account-modal__heading">
      <slot name="heading" />

      <v-btn
        class="grey--text text--darken-1"
        small
        icon
        @click.native="closeModal"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <div class="account-modal__content">

      <scrollable-container v-if="scrollableContainer">
        <data-row>
          <v-flex>
            <slot name="content" />
          </v-flex>
        </data-row>
      </scrollable-container>

      <v-container
        v-else
        grid-list-lg
      >
        <slot name="content" />
      </v-container>
    </div>

    <v-divider />

    <v-card-actions class="account-modal__actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex'

  // Components
  import ScrollableContainer from '@/components/ui/ScrollableContainer'
  import DataRow from '@/components/ui/Data/DataRow'

  export default {
    name: 'AccountModal',
    components: {
      ScrollableContainer,
      DataRow
    },
    props: {
      scrollableContainer: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal'])
    }
  }
</script>

<style lang="scss">
  .account-modal {
    &__heading,
    .container {
      padding-right: 30px;
      padding-left: 30px;
    }

    &__heading {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      padding-top: 21px;

      .v-btn {
        position: absolute;
        top: 11px;
        right: 0;
        margin-right: 17px;
      }
    }

    &__actions {
      padding-top: 15px;
      padding-bottom: 15px;
    }

    .container {
      padding-top: 4px;
      padding-bottom: 28px;
    }

    p, ul {
      font-size: 16px;
      font-weight: 400;
    }

    ul {
      list-style: none;
      padding-left: 0;
      padding-bottom: 11px;

      li {
        position: relative;
        padding-bottom: 8px;
        padding-left: 16px;

        &::before {
          position: absolute;
          left: 0;
          content: "—";
        }
      }
    }
  }
</style>
